import { Component, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LazyLoadEvent } from 'primeng/api/lazyloadevent';
import { Table } from 'primeng/table';
import { FilterValues } from 'src/app/shared/components/filter/filter.component';
import { DocumentService } from 'src/app/core/services/document.service';
import { S3StorageService } from 'src/app/core/services/s3-storage.service';
import { ToastService } from 'src/app/core/services/toast.service';

@Component({
    selector: 'app-my-document',
    templateUrl: './my-document.component.html',
    styleUrl: './my-document.component.scss',
    standalone: false
})
export class MyDocumentComponent {

  loading = false;
  error = '';
  documents = [];
  documentDetail: any = {};
  showModal: boolean = false;
  @ViewChild('dt') table!: Table;


  constructor(
    private documentService: DocumentService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toastService: ToastService,
    private s3Service: S3StorageService,
  ) { }

  ngOnInit() {
    this.activatedRoute.queryParamMap.subscribe(params => {
      const routeStatus = params.get('status') ?? '';
      const matchedStatus = this.getStatusOptionValue(routeStatus);
      const statusChanged = this.selectedStatus !== matchedStatus;

      this.selectedStatus = matchedStatus;

      if (statusChanged && this.table) {
        this.table.reset();
      }
    });
  }

  activeMenuId: string | null = null;
  @HostListener('document:click', ['$event'])
  clickOutside(event: any) {
    if (!event.target.closest('.action-wrapper')) {
      this.activeMenuId = null;
    }
  }

  toggleMenu(id: string) {
    this.activeMenuId = this.activeMenuId === id ? null : id;
  }

  getDocuments(event: LazyLoadEvent) {
    Promise.resolve().then(() => this.loading = true);
    const first = event?.first ?? 0;
    const rows = event?.rows ?? this.rows;
    const page = first / rows + 1;
    let startDate: string | null = null;
    let endDate: string | null = null;

    if (this.rangeDates && this.rangeDates.length === 2) {
      startDate = this.formatDate(this.rangeDates[0]);
      endDate = this.formatDate(this.rangeDates[1]);
    }

    const queryParams: any = {
      page: page,
      limit: rows,
      search: this.searchText,
      status: this.selectedStatus,
      startDate: startDate,
      endDate: endDate
    };

    this.documentService.getAllDocument(queryParams).subscribe(
      (res: any) => {
        this.documents = res?.data;
        this.totalRecords = res?.totalCount || 0;
        this.loading = false;
      },
      (err) => {
        this.loading = false;
      }
    );
  }

  getDocument(doc: any) {
    const id = doc?._id
    this.documentService.getDocumentDetail(id).subscribe((doc: any) => {
      this.showModal = true;
      this.documentDetail = doc;
      this.activeMenuId = null;
    },
      () => {});
  }

  closeModal() {
    this.showModal = false;
  }

  sendDocument = () => {
    this.router.navigate(['/customer/esign/send-document']);
  }

  downloadAndPreview(document: any) {
    this.loading = true;
    const id = document.documentId;

    this.documentService.downloadDocument(id).subscribe(
      (res: any) => {
        this.loading = false;
        const url = res?.signDocumentUrl;
        if (url) {
          window.open(url, '_self');
        }
      },
      (err: any) => {
        this.loading = false;
      }
    );
  }

  getUserStatus(users: any[] = []): number {
    if (!users || users.length === 0) {
      return 0;
    }

    const signedCount = users.filter(
      u => u.status?.toLowerCase() === 'signed'
    ).length;

    const percentage = (signedCount / users.length) * 100;
    return Math.round(percentage);
  }

  loadStatus: boolean = false;

  checkDocumentStatus(document: any) {
    const id = document.documentId;
    this.loadStatus = true;
    this.documentService.checkDocumentStatus(id).subscribe((res: any) => {
      this.loadStatus = false;

      if (res.status.toLowerCase() === 'signed' || res.status == true) {
        this.getDocument(document);
        this.getDocuments({ first: 0, rows: this.rows });
      }

    }, (err) => {
      this.loadStatus = false
    })
  }

  totalRecords = 0;
  rows = 10;
  searchText: any = '';
  selectedStatus: any = '';
  rangeDates: Date[] | null = null;

  statusOptions = [
    { label: 'All', value: '' },
    { label: 'Pending', value: 'Pending' },
    { label: 'Signed', value: 'Signed' },
  ];


  onFilterChange(values: FilterValues) {
    this.searchText = values.search;
    this.rangeDates = values.dateRange;
    const selectedStatus = this.getStatusOptionValue(values.status);

    if (this.selectedStatus !== selectedStatus) {
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { status: selectedStatus || null },
        queryParamsHandling: 'merge'
      });
    } else {
      this.table.reset();
    }
  }

  private getStatusOptionValue(status: any): string {
    const requestedStatus = String(status ?? '').toLowerCase();
    const matchedOption = this.statusOptions.find(
      option => String(option.value ?? '').toLowerCase() === requestedStatus
    );

    return matchedOption?.value ?? '';
  }

  formatDate(date: Date): string {
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, '0');
    const d = date.getDate().toString().padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  downloadDocumentAuditTrill(doc: any) {
    const documentId = doc.documentId
    if (!documentId) {
      console.error('No txnIds found');
      return;
    }

    this.documentService.downloadDocumentAuditTrill(documentId)
      .subscribe((url: string) => {
        window.open(url, '_blank');
        this.activeMenuId = null;

      });
  }

  signDocument(signerDoc: any) {
    const key = Object.keys(signerDoc).includes('esignRes');

    if (key) {
      const link = signerDoc?.esignRes[0]?.redirect_esign_url;
      window.open(link, '_blank');
    } else {
      this.toastService.showToaster(
        "Info",
        "Please complete the previous signer process first.",
        "info"
      );
    }

    this.activeMenuId = null;
  }

  resendMail(signerDoc: any) {
    const hasEsignRes = Object.keys(signerDoc).includes('esignRes');

    if (hasEsignRes) {
      this.documentService.resendMail(this.documentDetail?.documentId).subscribe((res: any) => {
        this.toastService.showToaster(
          "Success",
          `Mail resent successfully to ${signerDoc.email}.`,
          "success"
        );
      })

    } else {
      this.toastService.showToaster(
        "Info",
        "Please complete the previous signer process first.",
        "info"
      );
    }
  }

}
